
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M55 51H41v-5.171A19.012 19.012 0 0050.955 30H52a4 4 0 000-8h-2v-1c0-8.836-7.163-16-16-16H18a2.994 2.994 0 01-2.798-1.941 5.998 5.998 0 00-5.14 6.813c.302 2.15 1.798 3.846 3.733 4.636-.547 1.993-.795 4.643-.795 6.594V22h-1a4 4 0 000 8h1.045c.322 6.841 4.256 12.751 9.955 15.829V51H9a6 6 0 00-6 6v5h58v-5a6 6 0 00-6-6zM15 29.102v-8c0-1.787.236-4.34.747-6.143.155.012.307.041.464.041H44v2a5.998 5.998 0 005 5.91v6.192c0 9.374-7.626 17-17 17s-17-7.626-17-17zM25 51v-4.251c2.169.864 4.527 1.353 7 1.353s4.831-.489 7-1.353V51l-7 5-7-5z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M32 35a5 5 0 00-5 5h10a5 5 0 00-5-5zM51 9v10l8-11h-3l2-6H47l1 7zM22.447 22.105l-.894 1.79L25.764 26l-4.211 2.105.894 1.79L30.236 26zM42.447 28.105L38.236 26l4.211-2.105-.894-1.79L33.764 26l7.789 3.895z"}})])
          )
        }
      }
    